<template>
  <div class="main">
    <div style="width: 100%;">
      <van-notice-bar scrollable
                      left-icon="volume-o"
                      text="尊敬的用户您好，请您认真填写个人信息，这样我们才能提供更精准的服务！"
      />
    </div>
    <van-form style="width: 96%;margin-top: 1rem;">
      <van-field
          v-model="param.nickname"
          label="昵称"
          placeholder="昵称"/>
      <van-field required
                 v-model="param.name"
                 label="姓名（必填）"
                 placeholder="请填写身份证上的姓名"
                 :rules="[{ required: true, message: '请填写姓名' }]"
                 :error-message="nameErrorMessage"
                 @blur="nameValidate"
      />
      <van-field name="sexidValidator" label="性别（必）" required>
        <template #input>
          <van-radio-group v-model="param.sexid" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field name="radio" label="婚姻（选）" required>
        <template #input>
          <van-radio-group v-model="param.marital" direction="horizontal">
            <van-radio name="0">未婚</van-radio>
            <van-radio name="1">已婚</van-radio>
            <van-radio name="3">未说明</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field required v-model="param.phone"
                 type="tel"
                 label="手机号（必）"
                 placeholder="手机号"
                 :rules="[{ required: true, message: '请填写手机号' }]"
                 :error-message="phoneErrorMessage"
                 @blur="phonevalidate"
      />

      <van-field required v-model="param.cardid"
                 type="text"
                 :label="`${cardidTypeText}（必）`"
                 :placeholder="cardidTypeText"
                 :rules="[{ required: true, message: cardidTypeText }]"
                 :error-message="idcardErrorMessage"
                 @blur="idvalidate"
      >
        <template #button>
          <van-button size="small" style="cursor: none" type="info" @click.stop="changeCardidType">
            <van-icon name="exchange"/>
            换
          </van-button>
        </template>
      </van-field>

      <van-field v-if="cardidTypeText =='身份证'?false:true"
                 required
                 v-model="param.birthdate"
                 label="生日（必填）"
                 placeholder="生日"
                 @click="showAge = true"
                 :disabled="cardidTypeText =='身份证'?true:false"
                 :rules="[{ required: true, message: '请选择生日' }]"/>
      <van-field
          v-model="param.password"
          type="password"
          name="密码"
          label="密码（选）"
          placeholder="登录密码"
      />
      <van-field v-model="param.address" type="text" label="地址（选填）" placeholder="请填写现居住地址"/>
      <van-field
          v-if="phoneValid==1"
          v-model="param.code"
          :rules="[{ required: true, message: '' }]"
          center
          type="number"
          name="短信验证码"
          placeholder="请填写短信验证码"
          @input="formatterCode"
      >
        <template #button>
          <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"
                      color="linear-gradient(to right, #10E3E9, #409EFF)"
                      style="color: #fff;width: 90px;height: 35px;">{{ sendText }}
          </van-button>
        </template>
      </van-field>
      <div class="footer">
        <van-button :disabled="isSubmitting" round block native-type="button"
                    color="linear-gradient(to right, #10E3E9, #409EFF)"
                    style="margin-top: 5rem;" @click="register">{{ isSubmitting ? '提交中...' : '提交' }}
        </van-button>
      </div>
    </van-form>


    <van-popup v-model="showAge" round position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
          v-model="date"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="timeFormat"
          @cancel="showAge = false"
      />
    </van-popup>
    <van-popup v-model="showPhoneValid" round position="bottom">
      <div style="padding: 15px;font-size: 14px;color: gray">
        <van-form style="width: 96%;margin-top: 1rem;">
          <h2 style="color: #000;text-align: center;margin-bottom: 15px;">绑定手机号</h2>
          <div style="color: red"> 已有用户信息，但未绑定手机号 {{ param.phone }}<br/>请验证手机号绑定，该手机号用于登录
          </div>
          <van-field
              v-model="param.code"
              center
              type="number"
              name="短信验证码"
              placeholder="请输入短信验证码"
              @input="formatterCode"
          >
            <template #button>
              <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"
                          color="linear-gradient(to right, #10E3E9, #409EFF)"
                          style="color: #fff;width: 90px;height: 35px;">{{ sendText }}
              </van-button>
            </template>
          </van-field>
          <div class="footer">
            <van-button :disabled="isSubmitting" round block native-type="button"
                        color="linear-gradient(to right, #10E3E9, #409EFF)"
                        style="margin-top: 5rem;" @click="bindPhone">{{ isSubmitting ? '绑定中...' : '绑定' }}
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-action-sheet title="选择证件类型" v-model="cardidTypeSelectShow" :actions="cardidTypeTextActions"
                      @select="onSelectCardidType"/>
  </div>
</template>

<script>
import {bindingPhone, getRegistCode, register} from '@/api/module/user'
import {Dialog, Toast} from "vant";
import {encrypt} from '../../assets/utils/cryptoUtil.js'
import {getBirthdayByIdCard, getBirthdayByIdCardForDate} from '@/assets/utils/utils'

export default {
  name: "index",
  data() {
    return {
      nameErrorMessage: '',//姓名不能为空
      phoneErrorMessage: '',//手机号格式错误
      passwordErrorMessage: '',//密码由6位以上的数字与字符组成
      idcardErrorMessage: '',//身份证号码不正确
      date: '',
      showAge: false,
      showNative: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      param: {
        nickname: '',
        name: '',
        sexid: '',
        marital: '',
        phone: '',
        password: '',
        cardid: '',
        birthdate: '',
        address: '',
        code: '',
        bindingreferredcode:'' //绑定推荐码
      },
      passComplex: window.g.VUE_APP_PASS_COMPLEX,
      hospitalname: window.g.VUE_APP_HOSPITALNAME,
      sendText: '发送验证码',
      sendDisabled: false,
      isSubmitting: false,//是否禁用提交按钮
      showPhoneValid: false,//是否显示手机号验证层
      cardidTypeText: '身份证',
      cardidTypeTextActions: [{name: '身份证'}, {name: '护照'}],
      cardidTypeSelectShow: false,
      isRegister: window.g.VUE_APP_REGISTER_OPEN,
      // 是否开启手机验证码
      phoneValid: window.g.VUE_APP_REGISTER_PHONE_VERIFY_CODE,
    };
  },
  created() {
    // 判断是否开启注册，未开始则跳转登录页面
    if (!this.isRegister) {
      this.$router.push({name: 'login'})
    }
    this.param.bindingreferredcode = localStorage.getItem("referralcode")
  },
  methods: {
    changeCardidType() {
      this.cardidTypeSelectShow = true
    },
    onSelectCardidType(item) {
      this.cardidTypeText = item.name
      this.cardidTypeSelectShow = false
    },
    //修复ios 短信验证码自动填充时总是被复制两遍
    formatterCode(val) {
      if (val.length > 6) {
        this.code = val.substr(0, 6)
      }
    },
    //获取短信验证码
    getIdentifyCode() {
      let param = {
        phone: encrypt(this.param.phone),
        name: this.hospitalname
      }
      if (this.param.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      // if (this.imgcode == '' && this.imgcodeEnable=='1') {
      //   Toast.fail('请填写图形验证码！');
      //   return
      // }
      // if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase() && this.imgcodeEnable=='1') {
      //   Toast.fail('图形验证码错误！');
      //   this.imgcode = ''
      //   this.refreshCode();
      //   return
      // }
      if (!this.phonevalidate()) {
        return
      }
      getRegistCode(param).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg, {duration: 2000});
          if (res.data == 1) {
            this.sendDisabled = true
            //发送之后，60秒后才能重新发送
            const start = (e) => {
              let timer = null
              timer = setInterval(() => {
                this.sendText = '重发(' + e + ')'
                e--
                if (e < 0) {
                  clearInterval(timer)
                  this.sendDisabled = false
                  this.sendText = '发送验证码'
                }
              }, 1000)
            }
            start(60)
          }
        }
      })
    },
    register() {

      if (this.isSubmitting) return;
      if (this.nameValidate() && this.phonevalidate() && this.idvalidate()) {
        if (this.param.sexid == "") {
          Toast.fail('请选择性别');
          return;
        }
        if (this.param.marital == "") {
          Toast.fail('请选择婚姻');
          return;
        }
        if (this.param.birthdate == '') {
          Toast.fail('请选择出生日期');
          return
        }

        if (this.param.code == "" && this.phoneValid==1){
          Toast.fail('请填写短信验证码');
          return
        }

        //密码复杂性验证
        //2024-05-06 luotong 密码为空则不判断
        if (this.param.password != '' && this.passComplex) {
          //包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12
          let reg = new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$", "g")
          if (!reg.test(this.param.password)) {
            Dialog({
              message: "密码不符合复杂性要求：包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12",
              theme: 'round-button',
            });
            // Toast.fail('密码不符合复杂性要求：包含数字和字母，以及@#$三种符号，总长度6-8，必须包含2位及以上的字母，必须包含数字');
            return;
          }
        }

        this.isSubmitting = true;
        let opneid = ''
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        if (userinfo) {
          opneid = userinfo.opneid
          if (opneid != '' && opneid != undefined) {
            this.param.opneid = opneid
          }
        }

        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.name = encrypt(newParam.name.trim())
        newParam.cardid = encrypt(newParam.cardid.trim())
        newParam.phone = encrypt(newParam.phone.trim())
        newParam.password = encrypt(newParam.password.trim())
        newParam.institutionid = window.g.VUE_APP_INSTITUTIONID

        //20251110 增加验证码
        newParam.identifyingcode = newParam.code
        newParam.isVerifyPhone = this.phoneValid

        let wecahtUserinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        if (wecahtUserinfo != undefined && wecahtUserinfo != null) {
          //是否开启微信登录
          if (window.g.VUE_APP_ISWECHAT == '1') {
            newParam.wechatid = wecahtUserinfo.openid
            newParam.isbinding = "1"
          }
        }

        register(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
              this.isSubmitting = false;
            } else {

              localStorage.removeItem("referralcode") // 清空推荐码

              localStorage.setItem("loginuser", JSON.stringify(res.data))
              localStorage.setItem("token", res.data.token)
              Toast.success('注册成功！');
              this.$router.push({name: 'home'})//跳转到首页
            }
          } else if (res.code == 207) {
            Toast.fail(res.msg);
            this.isSubmitting = false;
          } else {
            if (res.data[0].phone == '') {
              this.isSubmitting = false;
              this.showPhoneValid = true;
            } else {
              this.isSubmitting = false;
              Toast.fail(res.msg);
            }
          }
        })
      }
    },
    bindPhone() {
      if (this.param.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      if (this.param.code == '') {
        Toast.fail('请填写验证码！');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      let params = {
        phone: encrypt(this.param.phone),
        code: this.param.code,
        cardid: encrypt(this.param.cardid),
      }
      bindingPhone(params).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg, {duration: 2000});
          localStorage.setItem("loginuser", JSON.stringify(res.data))
          localStorage.setItem("token", res.data.token)
          setTimeout(() => {
            this.$router.push({name: 'home'})//跳转到首页
          }, 2000)
        } else {
          Toast.fail(res.msg);
        }
      })
    },
    nameValidate() {
      if (this.param.name.trim() != "") {
        let regex = /^(?!\d+$)[\u4e00-\u9fa5\w]+$/
        if (!regex.test(this.param.name.trim())) {
          this.nameErrorMessage = '姓名不能为纯数字！'
          return false;
        }

        let carIdreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (carIdreg.test(this.param.name)) {
          this.nameErrorMessage = '姓名不能为身份证号码'
          return false;
        }
        this.nameErrorMessage = ''
        return true;
      } else {
        this.nameErrorMessage = '姓名不能为空！'
        return false;
      }
    },
    phonevalidate() {
      //手机号码校验 phoneErrorMessage
      // eslint-disable-next-line no-unreachable
      let myreg = /^((0\d{2,3}-\d{7,8})|(0\d{2,3}\d{7,8})|(\d{7,8})|(1[3456789]\d{9}))$/
      if (!myreg.test(this.param.phone)) {
        this.phoneErrorMessage = '请填写正确的手机号码'
        return false;
      } else {
        this.phoneErrorMessage = ''
        return true;
      }
    },
    idvalidate() {
      if (this.cardidTypeText == "身份证") {
        //身份证校验
        // eslint-disable-next-line no-unreachable
        let myreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (!myreg.test(this.param.cardid)) {
          this.idcardErrorMessage = '请填写正确的身份证号码'
          return false;
        } else {
          this.idcardErrorMessage = ''
          this.param.birthdate = getBirthdayByIdCard(this.param.cardid)
          return true;
        }
      } else if (this.cardidTypeText == "护照") {
        if (this.param.cardid.length <= 0) {
          this.idcardErrorMessage = '请填写护照'
          return false
        } else {
          return true
        }
      }
    },
    // 时间选择 弹框的确认按钮
    timeFormat() {
      let time = this.date
      this.showAge = false
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      if (month.toString().length == 1) {
        month = '0' + month
      }
      if (day.toString().length == 1) {
        day = '0' + day
      }
      this.param.birthdate = year + '-' + month + '-' + day
    }
  },
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
  display: flex;
  flex-flow: column;
  align-items: center;
}

.footer {
  width: 100%;
}
</style>
